module.exports = __webpack_public_path__ + "static/media/image17.5626ff70.jpg";